import { Role } from "@leap4/auth";
import { ITagMetrics } from "@leap4/entities-discrepancy-common";

export const baseBackendRoute = process.env.REACT_APP_BACKEND_BASE_URL + "";
export const BACKEND_SERVICE_NAME = "discrepancy-internal-backend";
export const logoutUrl = baseBackendRoute + "/app/logout";
export const requiredAuthRoles: Role[] = [Role.ADMIN];
export const meUrl = baseBackendRoute + "/app/me";
export const meMultiUrl = baseBackendRoute + "/app/me_multi"
export const setCookieUrl = baseBackendRoute + "/app/set-cookie";
export const loginUrl = (process.env.REACT_APP_AUTH_SERVER_BASE_URL || "https://api.auth.adte-system.com") + "/users/login";
export const publisherTagsBaseUrl = baseBackendRoute + "/publisher-tags"
export const publisherDataPointsBaseUrl = baseBackendRoute + "/publisher-data-points"
export const AdServerTagsBaseUrl = baseBackendRoute + "/adServer-tags"
export const adServersBaseUrl = baseBackendRoute + "/ad-servers"
export const HomeUrl = baseBackendRoute + "/home"
export const AlertsBaseUrl = baseBackendRoute + "/alerts";
export const GroupsBaseUrl = baseBackendRoute + "/groups";
export const dataPointsUrl = baseBackendRoute + "/data-points";
export const rescrapeUrl = dataPointsUrl + "/rescrape";
export const rescrapeStatusUrl = dataPointsUrl + "/rescrape-status";
export const partnersBaseUrl = baseBackendRoute + "/partners";
export const priceRulesBaseUrl = baseBackendRoute + "/pricerules"
export const networkPartnerBaseUrl = baseBackendRoute + "/networkPartners"
export const userViewsBaseUrl = baseBackendRoute + "/userview"
export const validationBaseUrl = baseBackendRoute + "/validation"
export const MatchingOrphanAdServerTags = AdServerTagsBaseUrl + "/orphan"
export const UpdateManualAlias = networkPartnerBaseUrl + "/manual"
export const ManualAliasLinkedTagsURL = networkPartnerBaseUrl + "/linkTags"

export type OptionalDays = 1 | 7 | 28 | 30 | -1
export type DaysType = {
    [T: string]: { label: string, value: OptionalDays }
}

export const DAYS: DaysType = {
    ONE: { label: 'Yesterday', value: 1 },
    SEVEN: { label: 'Last 7 Days', value: 7 },
    TWENTY_EIGHT: { label: 'Last 28 Days', value: 28 },
    FULL_MONTH_AGO: { label: 'Last Month', value: 30 }
}

export type ComparisonState = {
    compare: OptionalDays,
    data: ITagMetrics
}

export const DATE_FORMAT = "YYYY-MM-DD"
